import { defineComponent as n, computed as c, openBlock as p, createBlock as r, unref as s } from "vue";
import a from "../assets/icons/check.svg.mjs";
const u = /* @__PURE__ */ n({
  __name: "check-icon",
  props: {
    fill: { default: "currentColor" },
    size: { default: "md" }
  },
  setup(e) {
    const l = e, o = {
      sm: "12px",
      md: "16px",
      lg: "24px",
      xl: "32px",
      "2xl": "48px"
    }, i = c(() => o[l.size]);
    return (t, d) => (p(), r(s(a), {
      fill: t.fill,
      width: i.value,
      style: {
        verticalAlign: "middle",
        display: "inline-block",
        height: "auto"
      }
    }, null, 8, ["fill", "width"]));
  }
});
export {
  u as default
};
//# sourceMappingURL=check-icon.vue.mjs.map
